import React from 'react'
import AssessmentIcon from '@mui/icons-material/Assessment';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LeftBarSlides from '../ui/LeftBarSlides'
import DropDownMenu from '../ui/DropDownMenu'
import left from '../../images/js/left'
import LoadingSpinner from '../../components/ui/LoadingSpinner'
import right from '../../images/js/right'
import { dateParser, doesThisUserHaveThisAuthorization, IsThisUserThePresentationsCreator } from '../utilities/helperFunctions'
import { PLACEHOLDER_IMAGE_BYTES } from '../ui/helpers/PlaceholderImageConstant'

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

class Slides extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            "quickPicks": false,
            "showInfo": false,
            "qpSelections": {},
            "qpSelectionsArr": [],
            "chartpopOvers": [],
            "value": this.props.isPresentationBigLoaded ? 1 : 0,
            "userHasPermissionToViewChartQuery": false,
            "userWasCreator": false,
            "imageHash": Date.now(),
            "showCreateStoryButton": false,
            "showStoryHistoryButton": false,
            "showEditStoryButton": false,
            "showSlideshowButton": false
        };

        // Create the ref
        this.imageContainerRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.currentUser !== null) {
            this.setIfUserHasAppropriatePermissions(this.props.currentUser)
        }

        if (this.props.currentUser !== null && this.props.presentationView.presentationID !== undefined) {
            this.setIfUserIsCreator(this.props.currentUser, this.props.presentationView.presentation);
        }

        // By this time, I don't expect [this.imageContainerRef] to be ready, but if it is, lets run this
        if (this.imageContainerRef.current !== null) {
            let popoverData = this.getPopoverDataFromSlide(this.props.slide);
            this.setState({ chartpopOvers: popoverData });
        }

        if (this.props.presentationView && this.props.presentationView.needsUpdate) {
            this.setState({ "showStoryHistoryButton": true });
        } else {
            this.setState({ "showStoryHistoryButton": false });
        }

        window.addEventListener('resize', this.handleResize);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.showInfo !== prevState.showInfo) {
            this.setState({ value: this.state.showInfo ? 0 : 1, imageHash: Date.now() });
        }

        // change tab to preview on presentationload
        if (this.props.isPresentationBigLoaded !== prevProps.isPresentationBigLoaded && this.props.isPresentationBigLoaded) {
            this.setState({ value: 1, imageHash: Date.now() });
        }

        if (prevProps.currentUser === null && this.props.currentUser !== null) {
            this.setIfUserHasAppropriatePermissions(this.props.currentUser)

            if (this.props.presentationView.presentationID !== undefined) {
                this.setIfUserIsCreator(this.props.currentUser, this.props.presentationView.presentation)
            }
        }

        if (prevProps.presentationView.presentationID === undefined &&
            this.props.presentationView.presentationID !== undefined &&
            this.props.currentUser !== null) {
            this.setIfUserIsCreator(this.props.currentUser, this.props.presentationView.presentation);
        }

        if (this.props.presentationView && this.props.presentationView.needsUpdate && this.state.showStoryHistoryButton === false) {
            this.setState({ "showStoryHistoryButton": true });
        }

        if ((this.state.showEditStoryButton === false || this.state.showSlideshowButton === false) && this.props.doAllSlidesHaveTheirImagesLoaded) {
            this.setState({ "showEditStoryButton": true, "showSlideshowButton": true })
            if (this.props.currentUser !== null && this.props.presentationView.presentationID !== undefined) {
                this.setIfPresentationIsStory(this.props.presentationView.presentation)
            }
        }

        setTimeout(() => {
            if (this.imageContainerRef.current !== null) {
                let popoverData = this.getPopoverDataFromSlide(this.props.slide);
                let differenceCheck = this.isTheNewPopoverDataDifferentThanThePrevious(popoverData, prevState.chartpopOvers);
                if (differenceCheck) {
                    this.setState({ chartpopOvers: popoverData, imageHash: Date.now() });
                }
            }
        }, 1);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    isTheNewPopoverDataDifferentThanThePrevious = (newData, oldData) => {
        let rtnVal = false;

        if (newData.length !== oldData.length) {
            rtnVal = true;
        } else {
            // We will go through each item, one by one and see if we can find a matching element
            newData.forEach(d => {
                let lookup = oldData.find(x => x.id === d.id &&
                    x.slideX === d.slideX &&
                    x.slideY === d.slideY &&
                    x.chartImageWidth === d.chartImageWidth &&
                    x.chartImageHeight === d.chartImageHeight);

                if (lookup === undefined) rtnVal = true;
            });
        }

        return rtnVal;
    };

    getPopoverDataFromSlide = (slide) => {
        let rtnArr = [];
        let allowed = this.state.userHasPermissionToViewChartQuery && this.state.userWasCreator

        if (allowed && slide !== null && slide !== undefined && slide.xP3Charts !== undefined && slide.xP3Charts.length > 0) {
            slide.xP3Charts.forEach(c => {
                let percentageChange = this.imageContainerRef.current.clientWidth / c.slideImageWidth;
                rtnArr.push({
                    id: c.id,
                    slideX: (c.slideX * percentageChange),
                    slideY: (c.slideY * percentageChange),
                    chartImageWidth: (c.chartWidth * percentageChange),
                    chartImageHeight: (c.chartHeight * percentageChange)
                });
            });
        }

        return rtnArr;
    };

    findQPselections = () => {
        if (this.props.presentationView.quickPicks) {
            let obj = {}
            for (let i = 0; i < this.props.presentationView.quickPicks.length; i++) {
                let keys = Object.keys(this.props.presentationView.quickPicks[i].quickPicksTag.dataSourceSelections)
                let dsIndex = 0
                let maxIndex = 0
                let foundFirstMax = false  // this flag fixes bug where all datasource selections have the same number of selections, maxIndex would always be 0

                while (dsIndex < keys.length) {
                    if ((keys[dsIndex] !== "Unknown") && keys[dsIndex] !== "Logo") {
                        if (!foundFirstMax) {
                            maxIndex = dsIndex
                            foundFirstMax = true
                        }
                        if (this.props.presentationView.quickPicks[i].quickPicksTag.dataSourceSelections[keys[dsIndex]].length > this.props.presentationView.quickPicks[i].quickPicksTag.dataSourceSelections[keys[maxIndex]].length) {
                            maxIndex = dsIndex
                        }
                    }
                    dsIndex++
                }
                obj[this.props.presentationView.quickPicks[i].id] = {}
                if (this.props.presentationView.quickPicks[i].quickPicksTag.dataSourceSelections[keys[maxIndex]].length > 1) {
                    this.props.presentationView.quickPicks[i].quickPicksTag.dataSourceSelections[keys[maxIndex]].forEach(x => obj[this.props.presentationView.quickPicks[i].id][x.selectionAlias] = x.selectionValue)
                } else {
                    obj[this.props.presentationView.quickPicks[i].id][this.props.presentationView.quickPicks[i].quickPicksTag.targetAlias] = this.props.presentationView.quickPicks[i].quickPicksTag.targetSelection
                }

            }
            this.setState({ qpSelections: obj })

            let qpSelArr = []
            Object.keys(obj).forEach(function (key) {
                qpSelArr.push(obj[key]);
            });

            this.setState({ qpSelectionsArr: qpSelArr })
        }
    }

    emptyCheck = (str) => {
        switch (str) {
            case 'quickPicks':
                return (this.props.presentationView.quickPicks && (this.props.presentationView.quickPicks.length > 0)) ? true : false
            default:
                return true
        }
    }

    showMenu = (str) => {
        let keys = Object.keys(this.state)
        let obj = {}
        keys.map(x => { return obj[x] = false })
        obj[str] = true
        this.setState({ ...obj })
    }

    hideMenu = (str) => {
        this.setState({ [str]: false })
    }

    handleMouseEnter = (event) => {
        event.preventDefault()
        this.showMenu(event.target.dataset.name)
    }

    handleMouseExit = (event) => {
        event.preventDefault()
        this.hideMenu(event.target.dataset.name)
    }

    handleDownloadPresentation = (event) => {
        event.preventDefault()
        this.props.downloadPresentation(this.props.presentationView.presentationID, this.props.presentationView.presentation.name + ".pptx")
    }

    handleQPClick = () => {
        this.props.showQuickPickEditor(this.props.presentationView.presentationID);
    }

    handleChartQueryClick = () => {
        this.props.showChartQueryEditor();
    }

    handleViewSlideVersionDifferences = () => {
        this.props.showSlideVersionHistory();
    }

    handleInfoClick = () => {
        this.setState({ showInfo: true })
        this.findQPselections()
    }

    handlePreviewClick = () => {
        this.setState({ showInfo: false })
    }

    handleEditStoryClick = () => {
        this.props.showEditStory();
    }

    handleViewPresentation = (event) => {
        event.preventDefault()
        this.props.showPopup("slideViewPopup")
    }

    handleCreateStoryPopup = (event) => {
        event.preventDefault()
        this.props.showPopup("CreateStoryPopup", { "presentationView": this.props.presentationView })
    }

    handleResize = () => {
        setTimeout(() => {
            if (this.imageContainerRef.current !== null) {
                let popoverData = this.getPopoverDataFromSlide(this.props.slide);
                this.setState({ chartpopOvers: popoverData });
            }
        }, 1);
    };

    showQuickPicksButton = () => {
        if (this.props.isPresentationBigLoaded &&
            (this.isPresentationStandAlone() || this.isThisPresentationChildOfStoryRegardlessOfDeletedStatus() || this.isPresentationChildOfDeletedParent())) {
            return <Tab
                onClick={this.handleQPClick}
                label="Quick Picks"
                {...a11yProps(2)}
            />
        }
    };

    showQueryButton = () => {
        if (this.props.isPresentationBigLoaded &&
            this.props.slide !== undefined &&
            this.props.slide !== null &&
            this.props.slide.xP3Charts !== undefined &&
            this.props.slide.xP3Charts.length > 0 &&
            this.state.userHasPermissionToViewChartQuery === true &&
            this.state.userWasCreator === true) {
            return <Tab
                label="Chart Query"
                {...a11yProps(3)}
                onClick={this.handleChartQueryClick}
            />
        }
    }

    showSlideHistoryButton = (showStoryHistoryButton) => {
        if (this.props.isPresentationBigLoaded &&
            this.state.userWasCreator === true &&
            (this.isThisPresentationChildOfStory() || this.isThisPresentationStory())) {
            return <Tab
                label="Slide History"
                {...a11yProps(4)}
                onClick={this.handleViewSlideVersionDifferences}
                className={(showStoryHistoryButton) ? "updateAvailable" : ""}
            />
        }
    }

    isPresentationStandAlone = () => {
        return this.props.presentationView && this.props.presentationView.presentation && (this.props.presentationView.presentation.parentPresentation === undefined || this.props.presentationView.presentation.parentPresentation === null);
    }

    isPresentationChildOfDeletedParent = () => {
        return this.props.presentationView && this.props.presentationView.presentation && this.props.presentationView.presentation.parentPresentation && this.props.presentationView.presentation.parentPresentation.isDeleted === true;
    }

    isThisPresentationChildOfStoryRegardlessOfDeletedStatus = () => {
        return this.props.presentationView && this.props.presentationView.presentation && this.props.presentationView.presentation.parentPresentation && this.props.presentationView.presentation.parentPresentation.isStory === true;
    };

    isThisPresentationChildOfStory = () => {
        return this.props.presentationView && this.props.presentationView.presentation && this.props.presentationView.presentation.parentPresentation && this.props.presentationView.presentation.parentPresentation.isStory === true && this.props.presentationView.presentation.parentPresentation.isDeleted === false;
    };

    isThisPresentationStory = () => {
        return this.props.presentationView && this.props.presentationView.presentation && this.props.presentationView.presentation.isStory === true;
    };

    showEditStoryButton = () => {
        if (this.props.isPresentationBigLoaded &&
            this.isThisPresentationChildOfStory() &&
            this.state.userWasCreator === true &&
            this.state.showEditStoryButton) {
            return <button className="btn" onClick={this.handleEditStoryClick}>
                Edit Story
            </button>
        }
    }

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue
        });

    };

    showButtons = () => {
        if (this.props.isPresentationBigLoaded) {
            if (this.state.showInfo === true) { // clicked info
                return (<Tabs value={this.state.value} onChange={this.handleChange}>
                    <Tab label="Info" {...a11yProps(0)} onClick={this.handleInfoClick} />
                    <Tab label="Preview" {...a11yProps(1)} onClick={this.handlePreviewClick} />
                    {this.showQuickPicksButton()}
                    {this.showQueryButton()}
                    {this.showSlideHistoryButton(this.state.showStoryHistoryButton)}
                </Tabs>
                )

            }
            else {
                return (<Tabs value={this.state.value} onChange={this.handleChange}>
                    <Tab label="Info" {...a11yProps(0)} onClick={this.handleInfoClick} />
                    <Tab label="Preview" {...a11yProps(1)} onClick={this.handlePreviewClick} />
                    {this.showQuickPicksButton()}
                    {this.showQueryButton()}
                    {this.showSlideHistoryButton(this.state.showStoryHistoryButton)}
                </Tabs>
                )
            }


        } else {
            return (
                <Tabs value={this.state.value} onChange={this.handleChange}>
                    <Tab label="Info" {...a11yProps(0)} />
                    <Tab label="Preview" {...a11yProps(1)} />
                </Tabs>
            )
        }
    }

    showMain = () => {
        // preview tab
        if (this.props.isPresentationBigLoaded && this.state.showInfo === false && this.props.slide !== null) {
            return <div className="MuiTypography-root MuiTypography-body1" value={this.state.value} index={1}>
                <div className="showImgOut">
                    <div className="tableHeaderBox">
                        {(this.props.slide !== undefined && this.props.slide !== null) ? <button onClick={this.moveSlide} data-id={this.props.slide.slideNumber} data-name="back" style={{ 'left': "216px" }}>{left("black", "20px")}</button> : null}
                        <button style={{ 'left': "258px" }} data-category="createdBy">{this.renderSlideSubtitle()}</button>
                        {(this.props.slide !== undefined && this.props.slide !== null) ? <button onClick={this.moveSlide} data-id={this.props.slide.slideNumber} data-name="forward" style={{ 'left': "310px" }}>{right("black", "20px")}</button> : null}
                    </div>
                    <span className="slideImgContainer" ref={this.imageContainerRef}>
                        {this.state.chartpopOvers.map((popover, pIndex) => {
                            return (
                                <span
                                    key={`chart-popover-${popover.id}`}
                                    className="chartPopover"
                                    style={{
                                        "position": "absolute",
                                        "left": `${popover.slideX}px`,
                                        "top": `${popover.slideY}px`,
                                        "width": `${popover.chartImageWidth}px`,
                                        "height": `${popover.chartImageHeight}px`,
                                        "cursor": "pointer"
                                    }}
                                    onClick={() => this.props.showChartQueryEditor(popover.id)}>
                                </span>
                            )
                        })}
                        {this.renderCurrentSlideImage(this.props.slide, this.props.presentationView)}
                    </span>
                </div>
            </div>
        } else {
            // show info tab
            if (this.state.showInfo === true) {

                return (<div className="MuiTypography-root MuiTypography-body1" value={this.state.value} index={0}>
                    <ul className="userdetails">
                        <li>
                            <label>Presentation name :</label>
                            <span>{this.props.presentationView.presentation && this.props.presentationView.presentation.name}</span>
                        </li>
                        <li>
                            <label>Created By</label>
                            <span>{this.props.presentationView.presentation.createdBy}</span>
                        </li>
                        <li>
                            <label>Last Modified :</label>
                            <span>{this.props.presentationView.presentation && dateParser(this.props.presentationView.presentation.modifiedDate)}</span>
                        </li>
                        <li>
                            <label>QuickPicks :</label>
                            {(this.props.presentationView.quickPicks !== undefined) ? this.props.presentationView.quickPicks.map(x => <span key={x.id}>{x.tagName} - {x.quickPicksTag.targetSelection}<br /></span>) : null}
                        </li>
                        <li>
                            <label>Comps :</label>
                            {
                                this.state.qpSelectionsArr.map((q, r) =>
                                    <div key={`qp-${r}`} className="myTags">
                                        <span key={r}><b>Target Selection : {q["Target Selection"]}</b> </span>
                                        <span key={r + 1}>Target Selection Comp : {q["Target Selection - Comp"]} </span>
                                        <span key={r + 2}>Target Selection Comp 2 : {q["Target Selection - Comp2"] || q["Target Selection - Comp 2"]} </span>

                                    </div>
                                )
                            }
                        </li>
                    </ul>
                </div>
                )
            } else {
                return (<div className="MuiTypography-root MuiTypography-body1" value={this.state.value} index={this.state.showInfo ? 0 : 1}>
                    <ul className="userdetails">
                        <li>
                            <div className='slideLoadingSpinnerHolder'>
                                <LoadingSpinner loadingMessage="Loading Slides..." />
                            </div>
                        </li>
                        <li>
                            <label>Presentation name :</label>
                            <span>{this.props.presentationView.presentation && this.props.presentationView.presentation.name}</span>
                        </li>
                        <li>
                            <label>Created By</label>
                            <span>{this.props.presentationView.createdBy}</span>
                        </li>
                        <li>
                            <label>Last Modified :</label>
                            <span>{this.props.presentationView.presentation && dateParser(this.props.presentationView.presentation.modifiedDate)}</span>
                        </li>
                        <li>
                            <label>QuickPicks :</label>
                            {(this.props.presentationView.quickPicks !== undefined) ? this.props.presentationView.quickPicks.map(x => <span key={x.id}>{x.tagName} - {x.quickPicksTag.targetSelection}<br /></span>) : null}
                        </li>
                        <li>
                            <label>Comps :</label>
                            {
                                this.state.qpSelectionsArr.map((q, r) =>
                                    <div key={r}>
                                        <span key={r}><b>Target Selection : {q["Target Selection"]}</b> </span>
                                        <span key={r + 1}>Target Selection Comp : {q["Target Selection - Comp"]} </span>
                                        <span key={r + 2}>Target Selection Comp 2 : {q["Target Selection - Comp2"] || q["Target Selection - Comp 2"]} </span>
                                        <br></br>
                                    </div>
                                )
                            }
                        </li>
                    </ul>
                </div>
                )
            }
        }
    }

    showDropdown = () => {
        const ind = Object.values(this.state).indexOf(true)
        if (ind !== -1) {
            let name = Object.keys(this.state)[ind]
            return <DropDownMenu name={name}
                presentationView={this.props.presentationView}
                hideMenu={this.hideMenu}
                showMenu={this.showMenu}
                showQuickPickEditor={this.props.showQuickPickEditor}
                showGlobalEditor={this.props.showGlobalEditor}
            />
        } else {
            return null
        }
    }

    giveActive = () => {
        let keys = Object.keys(this.state)
        let vals = Object.values(this.state)
        if (vals.includes(true)) {
            return keys[vals.indexOf(true)]
        } else {
            return null
        }
    }

    lookUp = {
        "info": { left: "10px", width: "180px" },
        "dataSources": { left: "190px", width: "140px" },
        "queries": { left: "330px", width: "100px" },
        "quickPicks": { left: "430px", width: "130px" },
        "globals": { left: "560px", width: "120px" },
        "intellitext": { left: "680px", width: "120px" },
    }

    moveSlide = (event) => {
        event.preventDefault()
        if (event.target.dataset.name === "forward") {
            if (this.props.slideEnd !== this.props.slide.slideNumber) { this.props.viewSlide(parseFloat(this.props.slide.slideNumber) + 1) }
        } else {
            if (this.props.slide.slideNumber !== this.props.slideBegin) { this.props.viewSlide(parseFloat(this.props.slide.slideNumber) - 1) }
        }
    }

    renderCurrentSlideImage = (slide, presentationView) => {
        let rtnVal = <span></span>

        if (slide !== null && slide !== undefined &&
            presentationView !== null && presentationView !== undefined &&
            presentationView["slides"] !== null && presentationView["slides"] !== undefined) {

            presentationView.slides.forEach(s => {
                if (s["slideId"] === slide["slideId"]) {
                    if (s["slideImage"]["imageBytes"] === null) {
                        rtnVal = <img key={this.state.imageHash} className="slideImg loading" src={'data:image/jpeg;base64,' + PLACEHOLDER_IMAGE_BYTES} alt={`slide_${s["slideId"]}`} />
                    } else {
                        rtnVal = <img key={this.state.imageHash} className="slideImg" src={`data:image/jpeg;base64,${s["slideImage"]["imageBytes"]}`} alt={`slide_${s["slideId"]}`} />
                    }
                }
            })
        }

        return rtnVal
    }

    renderActive = (str) => {
        return (this.state[str] === true && this.emptyCheck(str)) ? `tableMenuButton open` : `tableMenuButton`
    }

    renderName = () => {
        return (this.props.presentationView.presentation !== undefined) ? ` ${this.props.presentationView.presentation.name}` : " Presentation"
    }

    renderSlideCount = () => {
        return (this.props.presentationView.slides !== undefined) ? `${this.props.presentationView.slides.length} Slides` : "Slides"
    }

    renderSlideSubtitle = () => {
        return (this.props.presentationView.slides !== undefined && this.props.slide !== null && this.props.slide !== undefined) ? `${this.props.slide.slideNumber} / ${this.props.presentationView.slides.length}` : null
    }

    render() {
        return (
            <div className="mainWrapper">
                <div className="bodyPart">
                    <div className="contentWrapper">
                        <h2 className="pageHead">
                            <AssessmentIcon />
                            <span className="mainTitleBox">{this.renderName()}</span>
                            <div className="rightButton">
                                {this.state.showCreateStoryButton === true && <button className="btn" onClick={this.handleCreateStoryPopup}>
                                    New Story
                                </button>}
                                {this.showEditStoryButton()}
                                {this.state.showSlideshowButton && <button className="btn" onClick={this.handleViewPresentation}>
                                    Slideshow View
                                </button>}
                                <button className="btn" onClick={this.handleDownloadPresentation}>Download</button>
                            </div>
                        </h2>
                        <div className="tabOutMain presentAtionOut">
                            <AppBar position="static">
                                <div className="TabsData">
                                    {this.showButtons()}
                                </div>
                            </AppBar>
                            <div className="tabsContainerBox">
                                {this.showDropdown()}
                                <div className="presentLeft">
                                    <LeftBarSlides
                                        presentationView={this.props.presentationView}
                                        slides={this.props.presentationView.slides}
                                        viewSlide={this.props.viewSlide}
                                        slide={this.props.slide}
                                        isPresentationBigLoaded={this.props.isPresentationBigLoaded}
                                    />
                                </div>
                                <div className="presentRight">
                                    {this.showMain()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    //#region Data Handlers and Events
    setIfUserHasAppropriatePermissions = (currentUser) => {
        let rtnVal = false

        if (currentUser !== null) {
            rtnVal = doesThisUserHaveThisAuthorization(currentUser, "ChartQuery")
            this.setState({ "userHasPermissionToViewChartQuery": rtnVal })
        }

        return rtnVal
    }
    setIfUserIsCreator = (currentUser, presentation) => {
        let rtnVal = IsThisUserThePresentationsCreator(currentUser, presentation)
        this.setState({ "userWasCreator": rtnVal })
        return rtnVal
    }
    setIfPresentationIsStory = (presentation) => {
        this.setState({ "showCreateStoryButton": presentation.isStory && presentation.isTemplate });
    }
    //#endregion
}

export default Slides